var blush_payload = "";
var blush_no_gh = "";
var gh_payload = "";
var blush_swm = "";
var blush_cookie_exists = false;
var nameArr = [];
var shop_type = "Beauty Expert";
var groupID = "";
var partnerID = "";
var blush_partnerID = "not_assigned";

function getQueryStringValue (key, id="") {  
  if (id == "no_decode"){ 
    return window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1");  
  } else if (id == ""){ 
    return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));  
  } else {
    var script_src = document.getElementById(id).getAttribute("src");
    //console.log(script_src);
    //console.log(window.location);
    return decodeURIComponent(script_src.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));  
  }
}